__turbopack_context__.v({
  "actions": "LeadForm-module__DaGy4a__actions",
  "back": "LeadForm-module__DaGy4a__back",
  "booking": "LeadForm-module__DaGy4a__booking",
  "card": "LeadForm-module__DaGy4a__card",
  "cardFull": "LeadForm-module__DaGy4a__cardFull",
  "choice": "LeadForm-module__DaGy4a__choice",
  "choices": "LeadForm-module__DaGy4a__choices",
  "consent": "LeadForm-module__DaGy4a__consent",
  "counter": "LeadForm-module__DaGy4a__counter",
  "error": "LeadForm-module__DaGy4a__error",
  "field": "LeadForm-module__DaGy4a__field",
  "fields": "LeadForm-module__DaGy4a__fields",
  "full": "LeadForm-module__DaGy4a__full",
  "hint": "LeadForm-module__DaGy4a__hint",
  "input": "LeadForm-module__DaGy4a__input",
  "label": "LeadForm-module__DaGy4a__label",
  "lead-step-back": "LeadForm-module__DaGy4a__lead-step-back",
  "lead-step-in": "LeadForm-module__DaGy4a__lead-step-in",
  "progress": "LeadForm-module__DaGy4a__progress",
  "progressBar": "LeadForm-module__DaGy4a__progressBar",
  "question": "LeadForm-module__DaGy4a__question",
  "section": "LeadForm-module__DaGy4a__section",
  "textStep": "LeadForm-module__DaGy4a__textStep",
  "trap": "LeadForm-module__DaGy4a__trap",
  "turnstile": "LeadForm-module__DaGy4a__turnstile",
});
